// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { lastDayOfYear as fn } from "../lastDayOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const lastDayOfYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default lastDayOfYearWithOptions;
